import { useEffect, useState } from 'react';
import api from '../api/axios';

/**
 * Loads an image from a protected backend endpoint (GridFS) by attaching
 * the JWT token via axios, then exposes it as an in-memory blob URL.
 */
const ChatImage = ({ fileUrl, alt = 'image', className = '', onClick }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoked = false;
    let createdUrl = null;
    if (!fileUrl) return;

    const path = fileUrl.startsWith('/api/') ? fileUrl.replace('/api/', '/') : fileUrl;
    api
      .get(path, { responseType: 'blob' })
      .then((res) => {
        if (revoked) return;
        createdUrl = URL.createObjectURL(res.data);
        setBlobUrl(createdUrl);
      })
      .catch(() => setError(true));

    return () => {
      revoked = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [fileUrl]);

  if (error) {
    return (
      <div data-testid="chat-image-error" className={`text-xs italic opacity-70 ${className}`}>
        Image indisponible
      </div>
    );
  }
  if (!blobUrl) {
    return (
      <div data-testid="chat-image-loading" className={`bg-gray-200 animate-pulse rounded ${className}`} style={{ minHeight: 120 }} />
    );
  }
  return (
    <img
      data-testid="chat-image"
      src={blobUrl}
      alt={alt}
      className={className}
      onClick={onClick}
    />
  );
};

export default ChatImage;
